<pages-container
  [title]="'main.competencies'"
  [icon]="'psychology'"
  [showSearch]="true"
  (onSearchSent)="handleSearch($event)">
  <div buttons>
    <button mat-raised-button
            [routerLink]="'/pages/settings/competency/new'"
            class="mat-white-bg">
      <span>{{'main.add' | translate}}</span>
    </button>
  </div>

  <div main-content class="competencies-list">
    <div class="competencies" cdkDropList (cdkDropListDropped)="dropCompetency($event)">
      @if (competencies().length) {
        @for (cp of competencies(); track cp.id; let i = $index) {
          <div class="com-grid" cdkDrag cdkDragLockAxis="y" cdkDragPreviewClass="com-preview">
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="com-header">
                      <div class="com-icon" [style.background-color]="cp.color"></div>
                      <span>{{cp.title}}</span>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="skill-list" cdkDropList (cdkDropListDropped)="drop($event, i)">
                  @for (skill of cp.skills; track skill) {
                    <div class="skill-content" cdkDrag cdkDragLockAxis="y">
                      <div class="name">{{skill.title}}</div>
                      <div class="icons">
                        <mat-icon style="color: orange" (click)="editSkill(skill)" class="sub-mat-icon">edit</mat-icon>
                        <mat-icon style="color: red" (click)="deleteSkill(skill)" class="sub-mat-icon">clear</mat-icon>
                      </div>
                    </div>
                  }
                </div>
                <div class="add-skill" (click)="addSkill(cp.id)">{{'competency.add_skill' | translate}}</div>
              </mat-expansion-panel>
            </mat-accordion>
            <mat-icon style="color: orange" (click)="editCompetency(cp)" class="main-mat-icon">edit</mat-icon>
            <mat-icon style="color: red" (click)="deleteCompetency(cp.id)" class="main-mat-icon">clear</mat-icon>
          </div>
        }
      }
    </div>
    @if (!competencies()?.length) {
      <div class="no-data-msg">
        <span class="mat-headline-6">{{'main.noData' | translate}}</span>
      </div>
    }
  </div>
</pages-container>
